import styles from './Bag.module.sass';
import Image from "next/image";
import cn from "classnames";
import SachaInventory from "@/components/Bag/SachaInventory";
import InventoryItem from "@/components/Bag/InventoryItem";
import XpBar_SVG from "@/components/svg/Bag/XpBar_SVG";
import InventoryObjectDescription from "@/components/Bag/InventoryObjectDescription";
import {Objects, useGameContext} from "@/context/GameContext";
import {useEffect, useMemo, useState} from "react";
import PillarItem from "@/components/Bag/PillarItem";

const Bag = ({className, ...props}) => {

	// Data
	const items = useMemo(() =>[
		{
			id: Objects.COMPASS,
			src: '/images/Game/Compass/compass.png',
			alt: 'Compass',
			class: styles.compass,
			width: 30,
			height: 40,
		},
		{
			id: Objects.PARCHMENT,
			src: '/images/Bag/parchment_inventory.png',
			alt: 'Parchment',
			class: styles.parchment,
			width: 35,
			height: 37,
		},
		{
			id: Objects.SWORD,
			src: '/images/Bag/sword_inventory.png',
			alt: 'Sword',
			class: styles.sword,
			width: 28,
			height: 62,
		},
		{
			id: Objects.CHEST,
			src: '/images/Bag/chest_inventory.png',
			alt: 'Chest',
			class: styles.chest,
			width: 48,
			height: 29,
		},
	], [])

	const objects = useMemo(() => [
		{
			id: Objects.COMPASS,
			name: 'BOUSSOLE',
			description: 'pour trouver TON chemin entrepreneurial.',
			src: '/images/Game/Timeline/compass--stroke.png',
			alt: 'Compass',
		},
		{
			id: Objects.PARCHMENT,
			name: 'PARCHEMIN',
			description: 'blabla juridique que seul ton avocat peut comprendre.',
			src: '/images/Game/Timeline/parchment--stroke.png',
			alt: 'Compass',
		},
		{
			id: Objects.SWORD,
			name: 'ÉPÉE',
			description: 'parfois nécessaire lors des négociations (les avocats sont immunisés contre cette arme).',
			src: '/images/Game/Timeline/sword--stroke.png',
			alt: 'Compass',
		},
		{
			id: Objects.CHEST,
			name: 'TRÉSOR',
			description: 'pour gagner de l’argent et éviter d\'en perdre.',
			src: '/images/Game/Timeline/chest--stroke.png',
			alt: 'Compass',
		}
	])

	const pillars = useMemo(() => [
		{
			icon: '/images/Bag/expertise.png',
			name: 'Expertise',
			text: 'Une expertise technique en droit des affaires pour l\'ensemble de nos collaborateurs. <br/><br/> Un savoir-faire spécifique en matière de structuration des groupes de sociétés et de capital-investissement. Une approche économique complémentaire à la formation juridique',
		},
		{
			icon: '/images/Bag/innovation.png',
			name: 'Innovation',
			text: 'Acteur et partenaire de l\'écosystème régional de l’innovation. Spécialiste de l\'accompagnement des start-ups et des sociétés innovantes',
		},
		{
			icon: '/images/Bag/pedagogie.png',
			name: 'Pédagogie',
			text: 'Rendre intelligible les enjeux juridiques et fiscaux. <br/> Proposer un accès simplifié à vos démarches juridiques.',
		},
		{
			icon: '/images/Bag/proximite.png',
			name: 'Proximité',
			text: 'Des interlocuteurs disponibles par téléphone et en visio. <br/>Des collaborateurs qui se déplacent dans vos locaux ou vous reçoivent dans nos bureaux.',
		},
	])

	// States
	const [selectedItem, setSelectedItem] = useState(items[0].id);
	const [selectedPillar, setSelectedPillar] = useState(0);

	const {gameTimelineRef, currentBagSection, isMobile} = useGameContext()

	const handleTagClick = (e) => {
		let labelTime = undefined;
		// If the element clicked as a class that contains 'book', then we are in the book section
		if(e.currentTarget.classList[0].includes('book')){
			labelTime = gameTimelineRef.current.labels['book__content_appeared']
		} else {
			labelTime = gameTimelineRef.current.labels['pillars_appeared']
		}

		if(labelTime === undefined) return
		const scrollToPosition = Math.ceil((labelTime / gameTimelineRef.current.duration()) * (gameTimelineRef.current.scrollTrigger.end))
		window.scrollTo({top: scrollToPosition, behavior: 'smooth'})
	}

	// Change the z-index of the pillar list to make the accordeon effect
	useEffect(() => {
		// Get the list of pillars
		const pillarsList = document.querySelectorAll('.pillar');

		let zIndex = 5
		let increaseZIndex = true
		pillarsList.forEach(pillar => {
			// Remove the previous class from the previous sibling
			if (increaseZIndex) {
				pillar.classList.forEach(item => {
					if(item.includes('clicked')) increaseZIndex = false
				})
			}

			pillar.style.zIndex = zIndex
			increaseZIndex ? zIndex++ : zIndex--
		})
	}, [selectedPillar])

	return (
		<section className={cn(styles.bag, className, 'gsap-bag')} {...props}>
			{/*region Global Section*/}
			<div className={styles.radial_background}/>
			<div className={cn(styles.bag_opening__container, 'gsap-bag_opening__container')}>
				{isMobile !== undefined ? ( isMobile
					? <Image className={cn(styles.bag_opening, 'gsap-bag_opening')}
						       src={'/images/Bag/bag_opening_gif_mobile.webp'}
						       alt={'Bag Opening'} width={784} height={704}
						       unoptimized={true}/>
					: <Image className={cn(styles.bag_opening, 'gsap-bag_opening')}
				       src={'/images/Bag/bag_opening_gif.webp'}
				       alt={'Bag Opening'} width={784} height={704}
				       unoptimized={true}/>
				) : <div className={cn(styles.bag_opening, 'gsap-bag_opening')}/>}
				{isMobile !== undefined ? (isMobile
										? <Image className={cn(styles.zip_bag_opening, 'gsap-zip_bag_opening')}
					         src={'/images/Bag/zip_bag_opening_gif_mobile.webp'}
					         alt={'Bag Zip Opening'} width={784} height={704}
					         unoptimized={true}/>
					: <Image className={cn(styles.zip_bag_opening, 'gsap-zip_bag_opening')}
					         src={'/images/Bag/zip_bag_opening_gif.png'}
					         alt={'Bag Zip Opening'} width={784} height={704}
					         unoptimized={true}/>
				) :  // Fallback for undefined isMobile
					<div className={cn(styles.zip_bag_opening, 'gsap-zip_bag_opening')}/>
				}
			</div>
			{/*endregion*/}

			{/*region Tags*/}
			<div className={styles.tags}>
				{/*Book*/}
				<div className={cn(styles.book_tag, {[styles.active]: currentBagSection === 'book'}, 'custom_pointer')}
				     onClick={handleTagClick}
				>
					<svg xmlns="http://www.w3.org/2000/svg"
					     width="78"
					     height="78"
					     viewBox="0 0 78 78"
					     fill="none"
					     className={styles.book_tag__background}>
						<path d="M78 8.47826V67.8261H76.3081V71.2174H74.6162V72.913H71.2343V74.6087H69.5425V76.3043H67.8506V78H10.1494V76.3043H8.45754V74.6087H6.76565V72.913H3.38377V71.2174H1.69188V67.8261H0V8.47826H1.69188L1.69565 5.08696H3.3913V3.3913H6.78261V1.69565H10.1739V0H67.8261V1.69565H71.2174V3.3913H74.6087V5.08696H76.3043L76.3081 8.47826H78Z"
						      fill="#A8A78A"/>
					</svg>
					<div className={styles.book_tag__img}>
						<Image src={'/images/Bag/book.png'} alt={'Book'} fill sizes={'4rem'}/>
					</div>
				</div>

				{/*Line separator*/}
				<div className={cn(styles.separator, {[styles.active]: currentBagSection === 'pillars'})}/>

				{/*Shirt*/}
				<div className={cn(styles.shirt, {[styles.active]: currentBagSection === 'pillars'}, 'custom_pointer')}
				     onClick={handleTagClick}
				>
					<svg xmlns="http://www.w3.org/2000/svg"
					     width="78"
					     height="78"
					     viewBox="0 0 78 78"
					     fill="none"
					     className={styles.shirt__background}>
						<path d="M78 8.47826V67.8261H76.3081V71.2174H74.6162V72.913H71.2343V74.6087H69.5425V76.3043H67.8506V78H10.1494V76.3043H8.45754V74.6087H6.76565V72.913H3.38377V71.2174H1.69188V67.8261H0V8.47826H1.69188L1.69565 5.08696H3.3913V3.3913H6.78261V1.69565H10.1739V0H67.8261V1.69565H71.2174V3.3913H74.6087V5.08696H76.3043L76.3081 8.47826H78Z"
						      fill="#A8A78A"/>
					</svg>
					<div className={styles.shirt__img}>
						<Image src={'/images/Bag/lawyer_shirt.png'} alt={'Book'} fill sizes={'4rem'}/>
					</div>
				</div>
			</div>
			{/*endregion*/}

			{/*region Book Section*/}
			<div className={cn(styles.book, 'gsap-book')}>
				<div className={cn(styles.book__opening__container, 'gsap-book_opening__container')}>
					{isMobile !== undefined ? (isMobile
						? <Image className={cn(styles.book__opening, 'gsap-book_opening')}
						       src={'/images/Bag/book_opening_gif_mobile.webp'}
						       alt={'Book Opening'}
						       width={784} height={704}
						       unoptimized={true}
						/>
						: <Image className={cn(styles.book__opening, 'gsap-book_opening')}
					       src={'/images/Bag/book_opening_gif.webp'}
					       alt={'Book Opening'}
					       width={784} height={704}
					       unoptimized={true}
						/>) : <div className={cn(styles.book__opening, 'gsap-book_opening')}/>}
				</div>

				<div className={cn(styles.book__left, 'gsap-book_content')}>
					{/*Username*/}
					<span className={styles.username}>JOUEUR 1</span>

					{/*Mobile Object*/}
					<div className={cn(styles.mobile_objects, {[styles.visible]: selectedItem !== null})}>
						{objects.map((object, index) => {
							return (
									<InventoryObjectDescription object={object}
									                            selectedItem={selectedItem}
									                            setSelectedItem={setSelectedItem}
									                            key={index}/>
							)
						})}
					</div>

					{/*Inventory*/}
					<div className={styles.inventory}>
						{items.map((item, index) => {
							return (
									<InventoryItem item={item}
									               className={item.class}
									               parentStyles={styles}
									               key={index}
									               selectedItem={selectedItem}
									               onClick={() => {
													   selectedItem === item.id ? setSelectedItem(null) : setSelectedItem(item.id)
												   }}
									/>
							)
						})}
						<SachaInventory className={styles.sacha_inventory}/>
					</div>

					{/*Xp Bar*/}
					<div className={styles.xp_bar}>
						<span className={styles.level}>LVL 5</span>
						<span className={styles.xp}>XP 50/100</span>
						<XpBar_SVG className={styles.xp_bar__svg}/>
					</div>

				</div>

				<div className={cn(styles.book__right, 'gsap-book_content')}>
					{/*Title*/}
					<span className={styles.title}>Objets</span>

					{/* Objects */}
					<div className={styles.objects}>
						{objects.map((object, index) => {
							return (
								<InventoryObjectDescription
										isPointer={true}
										object={object}
										selectedItem={selectedItem}
										setSelectedItem={setSelectedItem}
										onClick={() => {
											setSelectedItem(object.id)}}
										key={index} />
							)
						})}
					</div>
				</div>
			</div>
			{/*endregion*/}

			{/*region Pillar Section*/}
			<div className={cn(styles.pillars, 'gsap-pillars')}>

				{/*	Title*/}
				<div className={styles.pillars__container}>
					<div className={styles.pillars__title}>
						<span>Notre démarche repose sur 4 piliers fondamentaux :</span>
					</div>

					{/*Pillars*/}
					<div className={styles.pillars__list}>
						{pillars.map((pillar, index) => {
							return (
									<PillarItem pillar={pillar}
									            key={index}
									            pillarIndex={index}
									            selectedPillar={selectedPillar}
									            onClick={() => {
										            setSelectedPillar(index)
									            }}/>
							)
						})}
					</div>
				</div>
			</div>
			{/*endregion*/}
		</section>
	)
}
export default Bag;
